import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const S = {
  card: {
    background: "#fff", borderRadius: 14, border: "1.5px solid #f0e6ec",
    boxShadow: "0 1px 4px rgba(0,0,0,0.07)", padding: 24, marginTop: 24,
  },
  title: { fontSize: 15, fontWeight: 700, color: "#222", marginBottom: 4 },
  sub:   { fontSize: 13, color: "#888", marginBottom: 20 },
  addRow: { display: "flex", gap: 10, marginBottom: 24 },
  input: {
    flex: 1, padding: "9px 12px", border: "1.5px solid #e0d6dc",
    borderRadius: 8, fontSize: 14, outline: "none", color: "#222",
  },
  btnAdd: {
    background: "#9f0059", color: "#fff", border: "none",
    borderRadius: 8, padding: "9px 20px", fontSize: 14, fontWeight: 700, cursor: "pointer",
  },
  table: { width: "100%", borderCollapse: "collapse", fontSize: 13 },
  th: {
    background: "#f7f4f6", color: "#666", fontWeight: 700, padding: "9px 12px",
    textAlign: "left", borderBottom: "1.5px solid #f0e6ec",
    fontSize: 11, textTransform: "uppercase", letterSpacing: "0.05em",
  },
  td: { padding: "10px 12px", borderBottom: "1px solid #f0e6ec", color: "#333", verticalAlign: "middle" },
  editInput: {
    padding: "5px 8px", border: "1.5px solid #9f0059",
    borderRadius: 6, fontSize: 13, outline: "none", width: "100%",
  },
  btnIcon: { background: "none", border: "none", cursor: "pointer", padding: "4px 8px", borderRadius: 6, fontSize: 13, fontWeight: 700 },
  empty: { textAlign: "center", padding: "32px", color: "#aaa", fontSize: 13 },
};

const IndustriasAdmin = () => {
  const [items,    setItems]    = useState([]);
  const [nuevo,    setNuevo]    = useState("");
  const [editId,   setEditId]   = useState(null);
  const [editText, setEditText] = useState("");

  const cargar = () => {
    fetch(`${BASE}/buscar_industrias.php`)
      .then(r => r.json()).then(d => setItems(Array.isArray(d) ? d : [])).catch(() => {});
  };

  useEffect(() => { cargar(); }, []);

  const handleAgregar = async () => {
    if (!nuevo.trim()) { toast.error("Escribí una industria."); return; }
    const res = await fetch(`${BASE}/guardar_industria.php`, {
      method: "POST", body: new URLSearchParams({ nombre: nuevo.trim() }),
    });
    const data = await res.json();
    if (data.ok) { toast.success("Industria agregada"); setNuevo(""); cargar(); }
    else toast.error(data.error || "Error");
  };

  const handleEditar = async (it) => {
    if (!editText.trim()) { toast.error("El nombre no puede estar vacío."); return; }
    const res = await fetch(`${BASE}/editar_industria.php`, {
      method: "POST", body: new URLSearchParams({ id: it.id, oldName: it.nombre, newName: editText.trim() }),
    });
    const data = await res.json();
    if (data.ok) { toast.success("Industria actualizada"); setEditId(null); cargar(); }
    else toast.error(data.error || "Error");
  };

  const handleEliminar = async (it) => {
    if (!window.confirm(`¿Eliminar la industria "${it.nombre}"?`)) return;
    const res = await fetch(`${BASE}/eliminar_industria.php`, {
      method: "POST", body: new URLSearchParams({ id: it.id }),
    });
    const data = await res.json();
    if (data.ok) { toast.success("Industria eliminada"); cargar(); }
    else toast.error(data.error || "Error");
  };

  return (
    <div style={{ padding: "0 24px 24px" }}>
      <div style={S.card}>
        <p style={S.title}>Industrias</p>
        <p style={S.sub}>Industrias usadas para clasificar clientes y prospectos.</p>
        <div style={S.addRow}>
          <input style={S.input} placeholder="Nueva industria..." value={nuevo}
            onChange={e => setNuevo(e.target.value)} onKeyDown={e => e.key === "Enter" && handleAgregar()} />
          <button style={S.btnAdd} onClick={handleAgregar}>+ Agregar</button>
        </div>
        {items.length === 0 ? <p style={S.empty}>Sin industrias.</p> : (
          <table style={S.table}>
            <thead><tr>
              <th style={S.th}>#</th>
              <th style={S.th}>Industria</th>
              <th style={{ ...S.th, textAlign: "right" }}>Acciones</th>
            </tr></thead>
            <tbody>
              {items.map((it, i) => (
                <tr key={it.id} style={{ background: i % 2 === 0 ? "#fff" : "#fdf8fb" }}>
                  <td style={{ ...S.td, color: "#aaa", width: 40 }}>{it.id}</td>
                  <td style={S.td}>
                    {editId === it.id
                      ? <input style={S.editInput} value={editText} onChange={e => setEditText(e.target.value)}
                          onKeyDown={e => { if (e.key === "Enter") handleEditar(it); if (e.key === "Escape") setEditId(null); }} autoFocus />
                      : it.nombre}
                  </td>
                  <td style={{ ...S.td, textAlign: "right", whiteSpace: "nowrap" }}>
                    {editId === it.id ? (
                      <>
                        <button style={{ ...S.btnIcon, color: "#9f0059" }} onClick={() => handleEditar(it)}>✓ Guardar</button>
                        <button style={{ ...S.btnIcon, color: "#888" }} onClick={() => setEditId(null)}>✕</button>
                      </>
                    ) : (
                      <>
                        <button style={{ ...S.btnIcon, color: "#555" }} onClick={() => { setEditId(it.id); setEditText(it.nombre); }}>✏️</button>
                        <button style={{ ...S.btnIcon, color: "#dc2626" }} onClick={() => handleEliminar(it)}>🗑</button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default IndustriasAdmin;
